module.exports = __webpack_public_path__ + "static/support_hero-2a99cf26c16ff40263d1f52e817e66fb.jpg";